<template>
  <!--
        作者：zhuchangtao
        时间：2020-12-12
        描述：插件中心-抽奖活动-领取记录
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="抽奖码名称"><el-input size="small" v-model="formInline.lottery_code" placeholder="请输入抽奖码名称"></el-input></el-form-item>
        <el-form-item label="抽奖类型">
          <el-select size="small" v-model="formInline.type" placeholder="所有分类">
            <el-option label="全部" value=""></el-option>
            <el-option label="月抽奖" value="10"></el-option>
            <el-option label="复活奖" value="20"></el-option>
            <el-option label="豪华奖" value="30"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="中奖起始时间">
           <div class="block">
             <span class="demonstration"></span>
             <el-date-picker
               size="small"
               v-model="formInline.create_time"
               type="daterange"
               value-format="yyyy-MM-dd"
               range-separator="至"
               start-placeholder="开始日期"
               end-placeholder="结束日期"
             ></el-date-picker>
           </div>
         </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="win_id" label="ID" width="80"></el-table-column>
            <el-table-column prop="draw_date" label="期数"></el-table-column>
            <el-table-column prop="user.nickName" label="用户"></el-table-column>
            <el-table-column prop="lottery_code" label="抽奖码"></el-table-column>
            <el-table-column prop="type" label="抽奖类型">

              <template slot-scope="scope">
                <span v-if="scope.row.type == 10">月抽奖</span>
                <span v-if="scope.row.type == 20">复活奖</span>
                <span v-if="scope.row.type == 30">豪华奖</span>
              </template>
            </el-table-column>


            <el-table-column prop="lottery_prize_id" label="奖品ID"></el-table-column>
            <el-table-column prop="is_accept" label="是否领奖">

              <template slot-scope="scope">
                <span v-if="scope.row.is_accept == 10">否</span>
                <span v-if="scope.row.is_accept == 20">是</span>

              </template>
            </el-table-column>
            <el-table-column prop="no_accept_time" label="有效期">

            </el-table-column>
            <el-table-column prop="create_time" label="中奖时间"></el-table-column>
			<el-table-column prop="delivery_status" label="是否发货">
			
			  <template slot-scope="scope">
			    <span v-if="scope.row.delivery_status == 10">未发货</span>
			    <span v-if="scope.row.delivery_status == 20">已发货</span>
			
			  </template>
			</el-table-column>
            <el-table-column fixed="right" label="操作" width="160">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small" v-auth="'/plus/lottery/accept/detail'">详情</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import LotteryApi from '@/api/lottery.js';
  export default {
    data() {
      return {
        formInline: {
          lottery_code:'',
          type:'',
          create_time:'',
        },
        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.formInline; 
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        LotteryApi.acceptList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      /*打开编辑*/
      detailClick(row) {
        this.$router.push({
          path: '/plus/lottery/accept/detail',
          query: {
            win_id: row.win_id,

          }
        });
      },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getData();
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/accept/index.vue